import { SessionLayout } from "@/pages/App/SessionLayout"
import { Login } from "@/pages/Login"
import { LoginSSO } from "@/pages/LoginSSO"
import { RequestPassword } from "@/pages/RequestPassword"
import { ResetPassword } from "@/pages/ResetPassword"
import { RedirectSnaphire } from "@/pages/RedirectSnaphire"
import { User } from "@/pages/User"
import { PredictionDetail } from "@/pages/PredictionDetail"
import { VacancyDetail } from "@/pages/VacancyDetail"
import { Vacancy } from "@/pages/Vacancy"
import { CustomerDetail } from "@/pages/CustomerDetail"
import { Customer } from "@/pages/Customer"
import { Prediction } from "@/pages/Prediction"
import { Model } from "@/pages/Model"
import { Models } from "@/pages/Models"
import { CxResponses } from "@/pages/CxResponses"

import { PredictionList } from "@/features/PredictionList"

// need to put more specific match first then the more general match
export const routes = [
  {
    path: "/login",
    component: Login
  },
  {
    path: "/loginWithSSO",
    component: LoginSSO
  },
  {
    path: "/requestPassword",
    component: RequestPassword
  },
  {
    path: "/resetPassword/:resetToken",
    component: ResetPassword
  },
  {
    path: "/vacancy/:vacancyId/prediction/:predictionId/ats",
    component: RedirectSnaphire
  },
  {
    path: "/customers/:customerId",
    component: SessionLayout,
    routes: [
      {
        path: "/customers/:customerId/users",
        component: User
      },
      {
        path: "/customers/:customerId/vacancies/:vacancyId/predictions/:predictionId",
        component: PredictionDetail
      },
      {
        path: "/customers/:customerId/vacancies/:vacancyId",
        component: VacancyDetail,
        routes: [
          {
            path: "/customers/:customerId/vacancies/:vacancyId/completed",
            component: PredictionList
          },
          {
            path: "/customers/:customerId/vacancies/:vacancyId/in-progress",
            component: CxResponses
          }
        ]
      },
      {
        path: "/customers/:customerId/vacancies",
        component: Vacancy
      },
      {
        path: "/customers/:customerId/allCustomers/:selectedCustomerId",
        component: CustomerDetail
      },
      {
        path: "/customers/:customerId/allCustomers",
        component: Customer
      },
      {
        path: "/customers/:customerId/predictions/search",
        component: Prediction
      },
      {
        path: "/customers/:customerId/models/:predictorId",
        component: Model
      },
      {
        path: "/customers/:customerId/models",
        component: Models
      }
    ]
  },
  // this route is added to allow user to visit root and be redirected to vacancy page or login page
  {
    path: "/",
    component: SessionLayout
  }
]
